export default class Domain {
  public organizationId: string = ''
  public id: string = ''
  public name: string = ''

  // Constructor
  constructor(name: string = '') {
    this.name = name
  }
}
